var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-tabs"},[_c('router-link',{staticClass:"page-tab",attrs:{"to":"/iabf/admin/deadlines"}},[_vm._v("Deadlines & access")]),_c('router-link',{staticClass:"page-tab",attrs:{"to":"/iabf/admin/hold-log"}},[_vm._v("Hold log")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }